import { Card, Row, Col, Tabs } from "antd";
import { SearchBar } from "./components/search";
import { useEffect, useState, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useAppAuth } from "../../context/use-app-auth";
import useLamp from "./hooks/hook-lamp";
import { ItemCol } from "./components/item-col";
import { itemsTaps } from "./components/taps";
import requets from "../../api";
import { convertValue } from "./helpers/conversion-rules";

export default function Metrics() {
  const auth = useAppAuth();
  const req = useMemo(() => requets(auth.user?.access_token), [auth.user?.access_token]);
  const { data, device, setDevice, t } = useLamp();
  const { state } = useLocation();
  const [search, setSearch] = useState("");
  const [activeKey, setActiveKey] = useState("");
  const [lastMeasurement, setLastMeasurement] = useState([]);
  const [loadingMeasurement, setLoadingMeasurement] = useState(false);

  useEffect(() => {
    if (data.length > 0) {
      const selectedDevice = state && state.device ? state.device : data[0];
      setDevice(selectedDevice);
      setActiveKey(selectedDevice.devEui);
    }
  }, [data, state, setDevice]);

  useEffect(() => {
    if (!device?.devEui) return;
    setLastMeasurement([]);
    setLoadingMeasurement(true);

    Promise.all([
      req.get(`/metrics/${device.devEui}/last`),
      req.get(`/device/${device.devEui}/measurements`),
    ])
      .then(([metricsRes, measurementsRes]) => {
        const raw = Array.isArray(metricsRes.data?.measurements) ? metricsRes.data.measurements : [];

        const productMeasurements = measurementsRes.data?.product?.productMeasurements ?? [];
        const activeFields = new Set(
          productMeasurements.map((pm) =>
            (pm.measurement?.tag ?? "").replace(/^device_frmpayload_data_/i, "") || pm.measurement?.name
          ).filter(Boolean)
        );

        const seen = new Set();
        const converted = raw
          .filter((item) => {
            if (!item.field) return false;
            if (activeFields.size > 0 && !activeFields.has(item.field)) return false;
            if (seen.has(item.field)) return false;
            seen.add(item.field);
            return true;
          })
          .map((item) => {
            const { value, unit } = convertValue(item.value, item.unit);
            return { ...item, value: Number(value.toFixed(2)), unit };
          });

        setLastMeasurement(converted);
      })
      .catch((err) => {
        console.error("[Metrics] fetch error:", err);
        setLastMeasurement([]);
      })
      .finally(() => setLoadingMeasurement(false));
  }, [device, req]);

  const filterData = data.filter((item) => {
    return item.name.toLocaleLowerCase().includes(search.toLocaleLowerCase());
  });

  const items = itemsTaps({ t, device, data, lastMeasurement, loadingMeasurement });

  const isActiveHandlerItem = (device) => {
    setDevice(device);
    setActiveKey(device.devEui);
  };

  return (
    <div className="layout-content">
      <Row className="rowgap-vbox" gutter={[24, 0]}>
        <Col xs={24} sm={24} md={24} lg={24} xl={24} className="mb-24">
          <Card
            bordered={false}
            style={{
              borderRadius: 12,
              boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
            }}
          >
            <Row gutter={[24, 0]}>
              <Col span={4} pull={0} xs={24} sm={24} md={6}>
                <SearchBar t={t} setSearch={setSearch} />
                <Row className="container-lamp" justify="start" gutter={[0, 0]}>
                  {filterData.map((item, index) => (
                    <ItemCol
                      key={index}
                      t={t}
                      item={item}
                      isActiveHandlerItem={isActiveHandlerItem}
                      isActive={item.devEui === activeKey}
                    />
                  ))}
                </Row>
              </Col>
              <Col span={18} push={0} xs={24} sm={24} md={18}>
                <Tabs defaultActiveKey="1" items={items} />
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
